module.exports = __webpack_public_path__ + "img/stolik-6.808f8be0.jpg";